import React, {useState} from 'react';
import {Link} from "react-router-dom";

import TechnologySmallIcon from '../../components/technologySmallIcon.js'

import {CategoriesPageResult, Category, TechnologyInfo} from '../../../../server/routes/technology-type.js'

// interface Technology {
// 	TechnologyName: string;
// 	TechnologyURL: string;
// 	TechnologyIcon: string;
// }

// interface Category {
// 	CategoryName: string;
// 	CategoryURL: string;
// 	CategoryIcon: string;
// 	TechnologyCount: number;
// 	TechnologiesInfo: Technology[];
// 	TechnologyTrancated?: boolean;
// }

// interface CategoriesPageData {
// 	CategoryCount: number;
// 	TechnologyCount: number;
// 	Categories: Category[];
// }

interface CategoriesProps {
	server: string;
	pageData: unknown;
}

export default function Categories({server, pageData}: CategoriesProps) {

    const typedPageData = pageData as CategoriesPageResult
	const [data, setData] = useState(typedPageData);

	return (
        <>
            <CategoriesHeader props={data}/>
            <CategoriesControl props={data}/>
        </>
	)
}

interface ComponentProps {
	props: CategoriesPageResult;
}

function CategoriesHeader({props}: ComponentProps) {

    return (
        <section className="section section-sm text-center">
            <div className="container">
                <div className="text-center">
                    <h2>Web Technologies</h2>
                    <p>
                        <span style={{maxWidth: '690px'}}>
                            We monitor 120 million top-rated websites and identify what they are built with including
                            {' '}<TechnologyExamples />  
                            {' '}and many others. Below is the list of technologies that we track.
                        </span>
                    </p>
                </div>

                <br/>
                <br/>
                <div className= "container-fluid">
                    <div className= "row justify-content-center">
                        <div className= "col-sm-12 col-md-4">
                            <article className="counter-classic">
                                <div className="counter-classic-main">
                                    <div className="counter">{props.CategoryCount}</div>
                                </div>
                                <h4 className="counter-classic-title">Technology Categories</h4>
                            </article>
                        </div>
                        <div className= "col-sm-12 col-md-4">
                            <article className="counter-classic">
                                <div className="counter-classic-main">
                                    <div className="counter">{props.TechnologyCount}</div>
                                </div>
                                <h4 className="counter-classic-title">Technologies</h4>
                            </article>
                        </div>
                    </div>
                </div>                
                <br/>
                <br/>
                <div>			
                    <form className="rd-form rd-search form-inline" action="search" method="GET">
                        <div className="form-wrap">
                            <input required type="text" className="form-input" 
                            title="Type the technology or domain name without any special characters or quotation marks" 
                            placeholder="Lookup website or web technology (for example Magento or Shopify)" 
                             pattern="[\-a-zA-Z0-9\s\/\.\(\):_&@\?=]+"
                            name="q"/>
                        </div>
                        <div className="form-wrap form-button">
                            <button className="button button-secondary button-shadow" type="submit">Search</button>
                        </div>
                    </form>
                </div>            
            </div>
        </section>
    )
}

function TechnologyExamples() {

    const examples: [string, string][] = [
        ['Web Servers', '/technology-type/web-servers'],
        ['Web Application Frameworks', '/technology-type/web-application-frameworks'],
        ['Content Management Systems (CMS)', '/technology-type/content-management-system'],
    ]

    return (<>
            {
                examples.map((example, indexKey) =>
                    <span key={indexKey}>
                        <Link
                            key={indexKey}
                            to={example[1]}
                            className="link-hover" 
                            title={example[0]}
                        >
                            {example[0]}
                        </Link>
                        {', '}
                    </span>
                )
            }

    </>)
}

function CategoriesControl({props}: ComponentProps) {

    return (

        <section className="section section-md bg-gray-100">
            <div className="container">
                <div className="row">
                    {
                        props.Categories.map((category, indexKey) => 
                            <CategoryControl category={category} key={indexKey}/>
                        ) 
                    }
                </div>
            </div>
        </section>
    )
}

interface CategoryControlProps {
	category: Category;
}

function CategoryControl({category}: CategoryControlProps) {

    return (<>

        <div className="col-sm-4 col-md-4 col-lg-3" style={{marginBottom:'30px'}}>
            <div className="post-vacancy" style={{height:'100%'}}>
                <h4 className="text-left">
                    <Link 
                        to={`/technology-type/${category.CategoryURL}`}
                        className="link-hover"  
                        title={`${category.CategoryShortName} usage distribution and market share`}
                    >
                        <span 
                            className={`icon text-primary mdi ${category.CategoryIcon}`}
                        /> &nbsp; {category.CategoryShortName} ({category.TechnologyCount})
                    </Link>
                </h4>
                <br/>
                <hr/>
                <br/>
                {
                    category.TechnologiesInfo.map((technology, indexKey) =>
                        <TechnologyControl technology={technology} key={indexKey}/>
                    )
                }
                {
                    category.TechnologyTrancated &&
                    <>
                        <br/>
                        <hr/>
                        <p>
                            <Link 
                                to={`/technology-type/${category.CategoryURL}`}
                                className="link-hover" 
                                title={`${category.CategoryShortName} usage distribution and market share`}
                                > 
                                    More ...
                            </Link>
                        </p>
                    </>
                }
            </div>
        </div>    
    
    </>)
}

interface TechnologyControlProps {
	technology: TechnologyInfo;
}
 
function TechnologyControl({technology}: TechnologyControlProps) {

    return (<>
<Link 
    to={`/technology/${technology.TechnologyURL}`}
    className="link-hover"  
    title={`${technology.TechnologyShortName}`} 
><h5><TechnologySmallIcon 
            technologyIcon={technology.TechnologyIcon}
            technology={technology.TechnologyShortName}
        />&nbsp;{technology.TechnologyShortName}</h5>
</Link>
    </>)
}
